import merge from 'lodash.merge';
import assign from 'lodash.assign';

// Whitney SSm will be displayed in the SVG, but in the image export, the
// fonts prepended below ('Whitney SSm Regular') will be used.
const BASE_STYLE = {
  color: {
    background: '#fff',
    normal: '#333',
    light: '#666',
    hed: '#333',
    dek: '#666',
  },
  font: {
    light: 'sans-serif',
    normal: 'sans-serif',
    semibold: 'sans-serif',
    bold: 'sans-serif'
  },
  weight: {
    light: 300,
    normal: 400,
    semibold: 600,
    bold: 700,
  },
  size: {
    small: '11px',
    normal: '13px',
    large: '16px',
    xlarge: '16px',
  },
  lineHeight: {
    small: '16px',
    normal: '16px',
    large: '20px',
    xlarge: '20px',
  },
  annotations: {},
  headline: {},
  title: {},
  description: {},
  notes: {},
  source: {},
  tick: {},
  axes: {
    zeroGridLine: {},
    label: {
      seriesAreNotDates: {},
      bar: {
        x: {},
        y: {}
      }
    },
  },
  legend: {},
  dataLabel: {}
};

export function processStyles(options) {
  const STYLE = merge({}, BASE_STYLE);
  const { product, print } = options;
  if (__ALL__ || __WSJ__) {
    if (product === 'wsj') {
      if (print) {
        STYLE.annotations.fontSize = 7.5;
        STYLE.annotations.lineHeight = 10;
        STYLE.axes.label.bar.x.fontSize = 7.5;
        STYLE.axes.label.bar.x.fontWeight = 'normal';
        STYLE.axes.label.bar.x.lineHeight = 7.5;
        STYLE.axes.label.bar.y.fontSize = 7.5;
        STYLE.axes.label.bar.y.fontWeight = 'normal';
        STYLE.axes.label.bar.y.lineHeight = 7.5;
        STYLE.axes.label.color = '#666';
        STYLE.axes.label.fontSize = 7.5;
        STYLE.axes.label.fontWeight = 400;
        STYLE.axes.label.lineHeight = 7.5;
        STYLE.axes.label.seriesAreNotDates.fontSize = 7;
        STYLE.axes.label.seriesAreNotDates.fontWeight = 'normal';
        STYLE.axes.label.seriesAreNotDates.lineHeight = 8;
        STYLE.axes.zeroGridLine.color = '#333';
        STYLE.color.dek = '#000';
        STYLE.color.hed = '#000';
        STYLE.color.normal = '#000';
        STYLE.description.color = '#000';
        STYLE.description.fontFamily = '"DJ5RetinaNr Medium",sans-serif';
        STYLE.description.fontSize = 8.4;
        STYLE.description.fontWeight = 400;
        STYLE.description.lineHeight = 10;
        STYLE.font.bold = '"DJ5RetinaNr Bold",' + STYLE.font.bold;
        STYLE.font.light = '"DJ5RetinaNr Light",' + STYLE.font.light;
        STYLE.font.normal = '"DJ5RetinaNr Medium",' + STYLE.font.normal;
        STYLE.font.semibold = '"DJ5RetinaNr Semibold",' + STYLE.font.bold;
        STYLE.headline.color = '#000';
        STYLE.headline.fontFamily = '"DJ5RetinaNr Bold",sans-serif';
        STYLE.headline.fontSize = 12.6;
        STYLE.headline.fontWeight = 'normal';
        STYLE.headline.lineHeight = 14.4;
        STYLE.legend.fontSize = 7.5;
        STYLE.legend.fontWeight = 400;
        STYLE.legend.lineHeight = 'inherit';
        STYLE.legend.rectHeight = 6;
        STYLE.legend.rectWidth = 4;
        STYLE.lineHeight.large = 9.6;
        STYLE.lineHeight.normal = 8;
        STYLE.lineHeight.small = 7.2;
        STYLE.lineHeight.xlarge = 14.4;
        STYLE.size.large = 8.4;
        STYLE.size.normal = 7.5;
        STYLE.size.small = 6;
        STYLE.size.xlarge = 12.6;
        STYLE.tick.color = '#333';
        STYLE.tick.longSize = 5;
        STYLE.tick.mediumSize = 4;
        STYLE.tick.shortSize = 2;
        STYLE.tick.yOffset = 1;
        STYLE.weight.bold = 'normal';
        STYLE.weight.light = 'normal';
        STYLE.weight.normal = 'normal';
        STYLE.weight.semibold = 'normal';
      } else {
        STYLE.annotations.fontSize = '15px';
        STYLE.annotations.lineHeight = 20;
        // STYLE.axes.label.fontFamily = '"Retina", "Retina Narrow"'
        STYLE.axes.label.bar.x.fontSize = '15px';
        STYLE.axes.label.bar.x.fontWeight = 500;
        STYLE.axes.label.bar.x.lineHeight = 20;
        STYLE.axes.label.bar.y.fontSize = '13px';
        STYLE.axes.label.bar.y.fontWeight = 300;
        STYLE.axes.label.bar.y.lineHeight = 20;
        STYLE.axes.label.color = '#333';
        // weirdly breaks if I set below to '13px' in firefox
        STYLE.axes.label.fontSize = 13;
        STYLE.axes.label.fontWeight = 300;
        STYLE.axes.label.lineHeight = 20;
        STYLE.axes.label.seriesAreNotDates.fontSize = '15px';
        STYLE.axes.label.seriesAreNotDates.fontWeight = 500;
        STYLE.axes.label.seriesAreNotDates.lineHeight = 18;
        STYLE.axes.label.seriesAreNotDates.fontFamily = '"Retina", sans-serif';
        STYLE.axes.zeroGridLine.color = '#333';
        STYLE.description.color = '#333';
        STYLE.description.fontFamily = '"Retina", sans-serif';
        STYLE.description.fontSize = '15px';
        STYLE.description.fontWeight = 300;
        STYLE.description.lineHeight = 20;
        STYLE.font.bold = '"Retina",' + STYLE.font.bold;
        STYLE.font.light = '"Retina",' + STYLE.font.light;
        STYLE.font.normal = '"Retina",' + STYLE.font.normal;
        STYLE.font.semibold = '"Retina",' + STYLE.font.bold;
        STYLE.weight.bold = 500;
        STYLE.weight.light = 300;
        STYLE.weight.normal = 300;
        STYLE.weight.semibold = 500;
        STYLE.title.fontFamily = 'Retina Narrow';
        STYLE.title.fontSize = '13px';
        STYLE.headline.color = '#333';
        STYLE.headline.fontFamily = "Retina";
        STYLE.headline.fontSize = '18px';
        STYLE.headline.fontWeight = 500;
        STYLE.headline.lineHeight = '20px';
        STYLE.legend.fontSize = '15px';
        STYLE.dataLabel.fontSize = '15px';
        STYLE.dataLabel.lineHeight = '18px';
        STYLE.legend.fontWeight = 300;
        STYLE.legend.lineHeight = 18;
        STYLE.legend.rectHeight = 10;
        STYLE.legend.rectWidth = 10;
        STYLE.notes.lineHeight = 14;
        STYLE.source.lineHeight = 14;
        STYLE.source.fontWeight = 300;
        STYLE.tick.color = '#333';
        STYLE.tick.longSize = 7;
        STYLE.tick.mediumSize = 5;
        STYLE.tick.shortSize = 3;
        STYLE.tick.yOffset = 1.5;
        STYLE.weight.bold = 500;
        STYLE.weight.semibold = 500;
      }
    }
  }
  if (__ALL__ || __BARRONS__) {
    if (product === 'barrons') {
      if (print) {
        STYLE.color.normal = '#000000';
        STYLE.color.light = '#000000';
        STYLE.color.hed = '#000000';
        STYLE.color.dek = '#000000';
        STYLE.color.background = 'transparent';
        STYLE.font.light = 'Theinhardt,TheinhardtRegular,' + STYLE.font.light;
        STYLE.font.normal = 'Theinhardt,TheinhardtRegular,' + STYLE.font.normal;
        STYLE.font.semibold = 'Theinhardt,TheinhardtRegular,' + STYLE.font.bold;
        STYLE.font.bold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
        STYLE.size.small = '12px';
        STYLE.size.normal = '12px';
        STYLE.size.large = '9.5px';
        STYLE.size.xlarge = '14px';
        STYLE.lineHeight.large = '12.5px';
        STYLE.lineHeight.xlarge = '15.5px';
      } else {
        STYLE.color.background = 'transparent';
        STYLE.color.normal = '#8E99A2';
        STYLE.color.light = '#8E99A2';
        STYLE.color.hed = '#122225';
        STYLE.color.dek = '#8E99A2';
        STYLE.font.light = 'Theinhardt,TheinhardtRegular,' + STYLE.font.light;
        STYLE.font.normal = 'Theinhardt,TheinhardtRegular,' + STYLE.font.normal;
        STYLE.font.semibold = 'Theinhardt,TheinhardtRegular,' + STYLE.font.bold;
        STYLE.font.bold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
        STYLE.title.fontFamily = 'Theinhardt,TheinhardtRegular';
        STYLE.title.fontSize = '13px';
        STYLE.size.small = '12px';
        STYLE.size.normal = '12px';
        STYLE.size.large = '18px';
        STYLE.size.xlarge = '24px';
        STYLE.lineHeight.xlarge = '25px';
      }
    }
  }
  if (__ALL__ || __FINANCIALNEWS__) {
    if (product === 'financialnews') {
      STYLE.color.background = 'transparent';
      STYLE.color.normal = '#70808C';
      STYLE.color.light = '#70808C';
      STYLE.color.hed = '#005879';
      STYLE.color.dek = '#4D6172';
      STYLE.font.light = 'Theinhardt,TheinhardtRegular,' + STYLE.font.light;
      STYLE.font.normal = 'Theinhardt,TheinhardtRegular,' + STYLE.font.normal;
      STYLE.font.semibold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
      STYLE.font.bold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
      STYLE.size.small = '12px';
      STYLE.size.normal = '12px';
      STYLE.size.large = '16px';
      STYLE.size.xlarge = '24px';
      STYLE.title.fontFamily = 'Theinhardt,TheinhardtRegular';
      STYLE.title.fontSize = '13px';
      STYLE.lineHeight.small = '17px';
      STYLE.lineHeight.normal = '17px';
      STYLE.lineHeight.large = '22px';
      STYLE.lineHeight.xlarge = '28px';
    }
  }
  if (__ALL__ || __MARKETWATCH__) {
    if (product === 'marketwatch') {
      STYLE.font.light = 'Lato,' + STYLE.font.light;
      STYLE.font.normal = 'Lato,' + STYLE.font.normal;
      STYLE.font.semibold = 'Lato,' + STYLE.font.semibold;
      STYLE.font.bold = 'Lato,' + STYLE.font.bold;
      STYLE.font.axes = 'Lato,' + 'sans-serif';
      STYLE.title.fontFamily = 'Lato';
      STYLE.title.fontSize = '13px';
      STYLE.weight.light = 300;
      STYLE.weight.normal = 400;
      STYLE.weight.semibold = 700;
      STYLE.weight.bold = 900;
      STYLE.weight.axes = 700;
      STYLE.color.normal = '#555';
      STYLE.color.dek = '#555';
      STYLE.color.light = '#555';
      STYLE.color.axes = '#555';
      STYLE.size.small = '13px';
      STYLE.size.axes = '13px';
      STYLE.size.normal = '13px';
      STYLE.size.large = '16px';
      STYLE.size.xlarge = '28px';
      STYLE.lineHeight.small = '19px';
      STYLE.lineHeight.normal = '19px';
      STYLE.lineHeight.large = '25px';
      STYLE.lineHeight.xlarge = '34px';
    }
  }
  if (product === 'mansionglobal') {
    STYLE.font.light = '"Whitney SSm Light","Whitney SSm",Whitney,' + STYLE.font.light;
    STYLE.font.normal = '"Whitney SSm Regular","Whitney SSm",Whitney,' + STYLE.font.normal;
    STYLE.font.normal = '"Whitney SSm Book","Whitney SSm",Whitney,' + STYLE.font.normal;
    STYLE.font.semibold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.semibold;
    STYLE.font.bold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.bold;
    STYLE.title.fontFamily = 'Whitney SSm Regular","Whitney SSm",Whitney';
    STYLE.title.fontSize = '13px';
    STYLE.weight.light = 400;
    STYLE.weight.normal = 400;
    STYLE.weight.semibold = 600;
    STYLE.weight.semibold = 500;
    STYLE.weight.bold = 700;
    STYLE.color.light = '#666';
    STYLE.color.normal = '#333';
    STYLE.size.small = '14px';
    STYLE.size.normal = '14px';
    STYLE.size.large = '18px';
    STYLE.size.xlarge = '24px';
    STYLE.lineHeight.xlarge = '28px';
    STYLE.lineHeight.dek = '22px';
    STYLE.lineHeight.subdek = '22px';
    STYLE.notes.color = '#777';
    STYLE.axes.color = '#777';
    STYLE.legend.color = '#777';
    STYLE.annotations.color = '#777';
  }
  if (__ALL__ || __HEATSTREET__) {
    if (product === 'heatstreet') {
      STYLE.font.light = '"Ideal Sans","Ideal Sans A",' + STYLE.font.light;
      STYLE.font.normal = '"Ideal Sans","Ideal Sans A",' + STYLE.font.normal;
      STYLE.font.semibold = '"Ideal Sans Semi-Bold","Ideal Sans A",' + STYLE.font.semibold;
      STYLE.font.bold = '"Ideal Sans","Ideal Sans A",' + STYLE.font.bold;
      STYLE.weight.light = 300;
      STYLE.weight.normal = 300;
      STYLE.weight.semibold = 600;
      STYLE.weight.bold = 700;
      STYLE.size.small = '14px';
      STYLE.size.normal = '14px';
      STYLE.size.large = '14px';
      STYLE.size.xlarge = '22px';
    }
  }
  STYLE.base = {
    fontFamily: STYLE.font.normal,
    fontSize: STYLE.size.normal,
    fontWeight: STYLE.weight.normal,
    lineHeight: STYLE.lineHeight.normal,
    color: STYLE.color.normal,
  };
  STYLE.get = (size, options) => {
    const sizeStyle = STYLE[size];
    return sizeStyle ? assign({}, sizeStyle, options) : STYLE.base;
  };
  STYLE.small = STYLE.get('base', {
    fontSize: STYLE.size.small,
    lineHeight: STYLE.lineHeight.small
  });
  STYLE.normal = STYLE.get('base');
  STYLE.large = STYLE.get('base', {
    fontSize: STYLE.size.large,
    lineHeight: STYLE.lineHeight.large
  });
  STYLE.xlarge = STYLE.get('base', {
    fontSize: STYLE.size.xlarge,
    lineHeight: STYLE.lineHeight.xlarge
  });
  return STYLE;
}


// WEBPACK FOOTER //
// ./src/chart/style/index.js